<template>
  <div class="pub-page">
    <div class="pub-header d-flex align-items-center justify-content-between">
      <div>
      <text class="title me-1">{{$route.meta.title}}</text>
        <text class="text-danger small">请先完善队长信息后再添加队员，团队最多5名成员</text>
      </div>
      <el-button type="primary" class="ms-2 me-3" @click="handleAdd">添加队员</el-button>
    </div>
    <div class="pub-center">
      <el-table scrollbar-always-on border   :data="list" style="width: calc(100% - 30px);position: absolute;left: 15px;top:10px;padding-bottom: 30px"  v-loading="loading">
        <el-table-column label="年份"   min-width="80px" show-overflow-tooltip>
          <template #default="scope">
            {{scope.row.Year? scope.row.Year + "年":'-'}}
          </template>
        </el-table-column>
        <el-table-column label="参赛队名" min-width="200px" show-overflow-tooltip>
          <template #default="scope">
            {{scope.row.TeamName || '-'}}
          </template>
        </el-table-column>
        <el-table-column label="省份" min-width="150px" show-overflow-tooltip>
          <template #default="scope">
            {{scope.row.province || '-'}}
          </template>
        </el-table-column>
        <el-table-column label="所属大学" min-width="200px" show-overflow-tooltip>
          <template #default="scope">
            {{scope.row.UniversityName || "-"}}
          </template>
        </el-table-column>
        <el-table-column label="学院" min-width="150px" show-overflow-tooltip>
          <template #default="scope">
            {{scope.row.Collage || "-"}}
          </template>
        </el-table-column>
        <el-table-column label="专业" min-width="150px" show-overflow-tooltip>
          <template #default="scope">
            {{scope.row.Major || "-"}}
          </template>
        </el-table-column>
        <el-table-column label="排名" min-width="80px" show-overflow-tooltip>
          <template #default="scope">
            {{scope.row.TeamOrder || "-"}}
          </template>
        </el-table-column>
        <el-table-column label="身份证/护照" min-width="200px" show-overflow-tooltip>
          <template #default="scope">
            {{scope.row.CardId || "-"}}
          </template>
        </el-table-column>
        <el-table-column label="性别" min-width="80px" show-overflow-tooltip>
          <template #default="scope">
            {{scope.row.SexName||"-"}}
          </template>
        </el-table-column>
        <el-table-column label="学生类型" min-width="100px" show-overflow-tooltip>
          <template #default="scope">
            {{scope.row.TypeName || "-"}}
          </template>
        </el-table-column>
        <el-table-column label="年级" min-width="80px" show-overflow-tooltip>
          <template #default="scope">
            {{scope.row.GradeName || "-"}}
          </template>
        </el-table-column>
        <el-table-column label="入学年份" min-width="100px" show-overflow-tooltip>
          <template #default="scope">
            {{scope.row.EnrollYear || "-"}}
          </template>
        </el-table-column>
        <el-table-column label="手机号" min-width="120px" show-overflow-tooltip>
          <template #default="scope">
            {{scope.row.Phone || "-"}}
          </template>
        </el-table-column>
        <el-table-column label="邮箱" min-width="100px" show-overflow-tooltip>
          <template #default="scope">
            {{scope.row.Email || "-"}}
          </template>
        </el-table-column>
        <el-table-column label="学号" min-width="100px" show-overflow-tooltip>
          <template #default="scope">
            {{scope.row.StudentId || "-"}}
          </template>
        </el-table-column>
        <el-table-column label="创建时间" min-width="170px" show-overflow-tooltip>
          <template #default="scope">
            {{scope.row.CreatedTime || "-"}}
          </template>
        </el-table-column>
        <el-table-column label="队员姓名" fixed="right" min-width="100px" show-overflow-tooltip>
          <template #default="scope">
            {{scope.row.Name || "-"}}
          </template>
        </el-table-column>
        <el-table-column label="团队角色" fixed="right" min-width="100px" show-overflow-tooltip>
          <template #default="scope">
            <text v-if="scope.row.Role===1" class="fw-bold text-primary">队长</text>
            <text v-else>队员</text>
          </template>
<!--          <template #default="scope">-->
<!--            <el-switch-->
<!--                v-if="scope.row.loading"-->
<!--                :model-value="scope.row.Role===1"-->
<!--                class="ml-2"-->
<!--                inline-prompt-->
<!--                style="&#45;&#45;el-switch-on-color: #373e60; &#45;&#45;el-switch-off-color: #a9aaab"-->
<!--                active-text="队长"-->
<!--                inactive-text="队员"-->
<!--                loading-->
<!--            />-->
<!--            <el-switch-->
<!--                v-else-->
<!--                @click="handlePermission(scope.$index, scope.row)"-->
<!--                :model-value="scope.row.Role===1"-->
<!--                class="ml-2"-->
<!--                inline-prompt-->
<!--                style="&#45;&#45;el-switch-on-color: #373e60; &#45;&#45;el-switch-off-color: #a9aaab"-->
<!--                active-text="队长"-->
<!--                inactive-text="队员"-->
<!--            />-->
<!--          </template>-->
        </el-table-column>
        <el-table-column label="操作" width="150px" fixed="right">
          <template #default="scope">
            <el-button  size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button  size="small" :disabled="scope.row.Role===1"  type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pub-footer d-flex align-items-center justify-content-center">
      <el-pagination  v-show="total>0" background
                      layout="total, sizes, prev, pager, next"
                      :page-sizes="[10, 20, 30, 40]"
                      :total="total"
                      v-model:current-page="params.current"
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChange"/>
    </div>

    <AddStudentModel :item="choisedItem" @close="closeInfoChange" v-if="dialogVisible" @success="updateInfoChange"></AddStudentModel>
  </div>
</template>

<script setup>
import {onMounted, reactive, ref} from "vue";
import AddStudentModel from "@/components/AddStudentModel"
import {getMembers, removeMember, updateMember} from "@/api/student";
import {ElMessage,ElMessageBox} from "element-plus";
const dialogVisible = ref(false)
const choisedItem = ref()
import {STUDENTTYPE, SEXS, GRADE, getName} from "@/utils/commonSetting"
import {formatTime} from "@/utils/dateFun";
import {useStore} from "vuex";
import { useRouter } from "vue-router";
let router = useRouter();
const store = useStore()
const CaptainInfo = ref(null) // 队长信息
const params = reactive({
  pageSize:10,
  current:1,
  name:null
})
const total = ref(0)
const list = ref([])
const loading = ref(false)
onMounted(()=>{
  getList()
  getUserInfo()
})
// 获取用户信息
const incompleteInfo = ref(true)
const getUserInfo = async ()=>{
  await store.dispatch("loginModel/getUserInfo") //获取用户信息
  incompleteInfo.value = store.getters["loginModel/getStudentInfoIncomplete"]
  if(incompleteInfo.value){
    return  ElMessageBox.alert('请补充参赛队信息后再上传作品，去补充？', '补充信息', {
      confirmButtonText: '确定',
      callback: (action) => {
        if(action==='confirm'){ // 确定
          router.push({path:'/student/teams'})
        }
      },
    })
  }
}
// 列表
const getList = async (init)=>{
  if(init){
    params.current = 1
  }
  loading.value = true
  const res = await getMembers(params)
  loading.value = false
  if(res.err_code===0){
    total.value = res.total
   let data = res.data || []
    data.forEach(item=>{
      if(item.Role==1){
        CaptainInfo.value = item
      }
      // 省份
      if( item.Team && item.Team.University){
        item.province = item.Team.University.Province
        item.UniversityName = item.Team.University.Name
      }
    //  队名
      if(item.Team && item.Team.Name){
        item.TeamName = item.Team.Name
      }
    //  类型名称
      item.TypeName = getName(STUDENTTYPE,item.Type)
      //  性别
      item.SexName = getName(SEXS,item.Sex)
      //  年级
      item.GradeName = getName(GRADE,item.Grade)
    //  创建时间
      if(item.CreatedAt){
        item.CreatedTime = formatTime(item.CreatedAt)
      }
    })
    list.value = data
  }else{
    return  ElMessage.warning("获取列表失败")
  }
}


// 添加
const handleAdd = ()=>{
  if(!CaptainInfo.value){
    return ElMessage.warning("等待获取队长信息")
  }
  if(!CaptainInfo.value.CardId || !CaptainInfo.value.Collage|| !CaptainInfo.value.Email|| !CaptainInfo.value.EnrollYear|| !CaptainInfo.value.Grade|| !CaptainInfo.value.Major|| !CaptainInfo.value.Name|| !CaptainInfo.value.Phone|| !CaptainInfo.value.Sex|| !CaptainInfo.value.StudentId){
    // return ElMessage.warning("队长信息不完整，请先补充队长信息再添加")
    return  ElMessageBox.alert('队长信息不完整，请先补充队长信息再添加新队员', '完善信息', {
      confirmButtonText: '已知晓',
      callback: (action) => {
        if(action==='confirm'){ // 确定
          handleEdit(0,CaptainInfo.value)
        }
      },
    })
  }
  choisedItem.value = {}
  dialogVisible.value = true
}
// 编辑
const handleEdit = (index,item)=>{
  choisedItem.value = item
  dialogVisible.value = true
}
// 删除
const handleDelete = (number,item)=>{
  ElMessageBox.alert('确定要删除吗？', '删除', {
    confirmButtonText: '确定',
    callback: (action) => {
      if(action==='confirm'){ // 确定
        // const needInitQuery = needInitQueryFun(total.value,queryParam.pageSize,number)
        removeMember({ids:[item.ID]}).then(res=>{
          if(res.err_code === 0){
            ElMessage.success(`删除成功`)
            getList(true) // 重新请求
          }else{
            ElMessage.error(res.err_msg ||`删除失败,请稍后再试`)
          }
        })
      }
    },
  })
}

// 关闭信息修改
const closeInfoChange = ()=>{
  dialogVisible.value = false
}
// 新建或修改成功
const updateInfoChange = ()=>{
  dialogVisible.value = false
  getList(true)
}
const handlePermission = async (index,item)=>{
  const params = {
    ...item,
    Role:item.Role===1?2:1,
  }
  list.value[index].loading = true
  const res = await updateMember(params)
  list.value[index].loading = false
  if(res.err_code===0){
    list.value[index].Role = params.Role // 直接更新
    ElMessage.success("修改成功")
  }else{
    ElMessage.error("修改失败")
  }
}
// 页码改变
const handleSizeChange = (event) => {
  if(params.pageSize !==event){
    params.current = 1
    params.pageSize = event
    getList()
  }
}
const handleCurrentChange = ()=>{
  getList()
}
</script>

<style scoped lang="scss">


</style>
